module.exports = __webpack_public_path__ + "static/media/image106.318d88f4.png";